var _rect, _linearGradient, _feGaussianBlur, _feComposite, _feComposite2, _feOffset, _feDisplacementMap, _feComposite3, _feComposite4, _feComposite5, _feComposite6, _feGaussianBlur2, _feGaussianBlur3, _feOffset2, _feComposite7, _feComposite8, _feColorMatrix, _feFlood, _feBlend, _feBlend2, _feColorMatrix2, _feComposite9, _feColorMatrix3, _feColorMatrix4, _feComposite10, _feGaussianBlur4, _feGaussianBlur5, _feBlend3, _feGaussianBlur6, _feGaussianBlur7, _feGaussianBlur8, _linearGradient2, _linearGradient3, _feGaussianBlur9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Sands0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 700,
    viewBox: "0 0 1400 700",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient64770"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop64766"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop64768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient63006"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.52880657,
    id: "stop63002"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop63004"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 603.86919,
    y: 125.86501,
    width: 718.42049,
    height: 486.48947,
    id: "rect62313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient987"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abdee5",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop983"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7e7ef",
      stopOpacity: 1
    },
    offset: 0.13817221,
    id: "stop1567"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1dee5",
      stopOpacity: 1
    },
    offset: 0.5061332,
    id: "stop1697"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9e4e5",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop985"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient987",
    id: "linearGradient989",
    x1: 686.16467,
    y1: 0,
    x2: 686.58972,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 1.8665047,
    y: -0.43325236,
    width: 1.0679584,
    x: -0.033979213,
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter123839"
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.294963,
    result: "result8",
    in: "SourceGraphic",
    id: "feGaussianBlur123821"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    operator: "xor",
    result: "result18",
    in2: "result8",
    id: "feComposite123823"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    k2: 1,
    operator: "arithmetic",
    result: "result16",
    in2: "result18",
    in: "result8",
    id: "feComposite123825",
    k1: 0,
    k3: 0,
    k4: 0
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    result: "result17",
    in: "SourceGraphic",
    id: "feOffset123827"
  })), _feDisplacementMap || (_feDisplacementMap = /*#__PURE__*/React.createElement("feDisplacementMap", {
    in2: "result18",
    in: "result17",
    xChannelSelector: "A",
    yChannelSelector: "A",
    scale: 100,
    result: "result4",
    id: "feDisplacementMap123829"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    result: "result2",
    operator: "arithmetic",
    in: "SourceGraphic",
    k1: 0,
    k3: 1,
    id: "feComposite123831",
    k2: 0,
    k4: 0
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result2",
    result: "fbSourceGraphic",
    in: "result16",
    operator: "in",
    id: "feComposite123833"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "result14",
    id: "feComposite123835"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    result: "result15",
    in2: "SourceGraphic",
    operator: "in",
    in: "result14",
    id: "feComposite123837"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter240538",
    x: -0.07132221,
    y: -0.55248873,
    width: 1.1426444,
    height: 2.1049775
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.926879,
    id: "feGaussianBlur240540"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter259650",
    x: -0.013241726,
    y: -0.056005576,
    width: 1.0333802,
    height: 1.1411807
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    in: "SourceAlpha",
    stdDeviation: 4,
    id: "feGaussianBlur259644"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    result: "result4",
    id: "feOffset259646"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result4",
    operator: "xor",
    result: "result3",
    id: "feComposite259648"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter261609",
    x: -0.017303532,
    y: -0.00028002822,
    width: 1.0346071,
    height: 1.0005601
  }, _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "arithmetic",
    k1: 8.38323,
    k2: 0,
    result: "composite1",
    id: "feComposite261595",
    k3: 0,
    k4: 0
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    values: 0,
    type: "saturate",
    result: "colormatrix1",
    id: "feColorMatrix261597"
  })), _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(23,16,12)",
    result: "flood1",
    id: "feFlood261599"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "darken",
    result: "blend1",
    id: "feBlend261601"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "darken",
    result: "blend2",
    id: "feBlend261603"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    values: 1,
    type: "saturate",
    result: "colormatrix2",
    id: "feColorMatrix261605"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite261607"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix264867"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix264869",
    in: "fbSourceGraphic",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.2125 -0.7154 -0.0721 1 0 ",
    result: "colormatrix"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "colormatrix",
    id: "feComposite264871",
    in: "fbSourceGraphic",
    operator: "arithmetic",
    k2: 1,
    k3: 0,
    k4: 0,
    result: "composite",
    k1: 0
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur264873",
    stdDeviation: "5.21698 0.01",
    result: "blur1"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur264875",
    in: "composite",
    stdDeviation: "0.01 0.01",
    result: "blur2"
  })), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blur1",
    id: "feBlend264877",
    in: "blur2",
    mode: "darken",
    result: "blend"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter261751",
    x: -0.78099067,
    y: -0.78099067,
    width: 2.5619813,
    height: 2.5619813
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.778894,
    id: "feGaussianBlur261753"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter262047",
    x: -0.25226838,
    y: -0.25226838,
    width: 1.5045368,
    height: 1.5045368
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3578275,
    id: "feGaussianBlur262045"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter262521",
    x: -0.27031779,
    y: -0.27031779,
    width: 1.5406356,
    height: 1.5406356
  }, _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8842687,
    id: "feGaussianBlur262519"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient63006",
    id: "linearGradient63008",
    x1: 1006.2739,
    y1: 174.41577,
    x2: 1007.9216,
    y2: 409.72641,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient64770",
    id: "linearGradient64772",
    x1: 691.92188,
    y1: 293.40808,
    x2: 1307.5957,
    y2: 293.40808,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter64774",
    x: -0.0059942757,
    y: -0.016254155,
    width: 1.0119886,
    height: 1.0325083
  }, _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3293828,
    id: "feGaussianBlur64776"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer12",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "url(#linearGradient989)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 44.9997
    },
    id: "rect867",
    width: 1400,
    height: 700,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#ffecad",
      fillOpacity: 0.562,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.384974,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 0.428,
      filter: "url(#filter262521)"
    },
    id: "circle262049",
    cx: 421,
    cy: 65,
    r: 35,
    transform: "matrix(3.1775257,0,0,2.123471,-916.73829,-73.025614)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#fffdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.407395,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 0.428,
      filter: "url(#filter262047)"
    },
    id: "circle261755",
    cx: 421,
    cy: 65,
    r: 35,
    transform: "matrix(2.4546197,0,0,2.4546197,-612.39488,-94.550281)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#ffe9a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 0.428,
      filter: "url(#filter261751)"
    },
    id: "path261651",
    cx: 421,
    cy: 65,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text62311",
    style: {
      fontSize: 400,
      lineHeight: 0,
      fontFamily: "sans-serif",
      whiteSpace: "pre",
      shapeInside: "url(#rect62313)",
      shapePadding: 2.82843,
      display: "inline",
      mixBlendMode: "normal",
      fill: "url(#linearGradient63008)",
      fillOpacity: 1,
      stroke: "#ede9e0",
      strokeOpacity: 1,
      filter: "url(#filter64774)"
    },
    x: 546.38672,
    y: 0,
    transform: "matrix(1.1561972,0,0,2.1155151,-137.77474,-229.46523)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 679.61719,
    y: 402.39245,
    id: "tspan279"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      fontSize: 300,
      lineHeight: 1.25,
      InkscapeFontSpecification: "'sans-serif, Bold'",
      textAlign: "end",
      textAnchor: "end"
    },
    id: "tspan277"
  }, "404")))), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.783688,
      mixBlendMode: "normal",
      fill: "#fedec2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 1,
      filter: "url(#filter240538)"
    },
    id: "rect237587",
    width: 1511.7943,
    height: 195.16147,
    x: -63.63961,
    y: 451.13412
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3349",
    style: {
      opacity: 1,
      fill: "#fead67",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 44.9997
    },
    d: "m 1400,577.60724 c -44.0497,7.55391 -87.1644,25.11556 -129.9653,20.43479 C 978.22699,566.1295 747.37269,599.21754 508.05414,575.8945 345.8854,560.09017 171.27025,602.96053 0,577.60724 v 122.39278 h 1400 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2603",
    style: {
      opacity: 1,
      fill: "#fed1aa",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 44.9997
    },
    d: "m 0,577.60724 c 466.66667,0 933.33333,81.51346 1400,0 V 700.00002 H 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5250",
    style: {
      opacity: 1,
      fill: "#fec08a",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 44.9997
    },
    d: "m 1400,577.60722 c -466.66667,0 -933.33333,81.51346 -1400,0 V 700 h 1400 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Sands0);
export default __webpack_public_path__ + "static/media/404sands0.6f2352c63636a3b8f5880fff21138257.svg";
export { ForwardRef as ReactComponent };